import { useAuditClientConfigQuery } from '@app/modules/audit/modules/station-audit/hooks/useAuditClientConfigQuery';
import { auditReports } from '@mi-front/api-clients';
import * as yup from 'yup';

/** Inclusive lower bound for audio match include seconds. */
export const GIP_EXPORT_AUDIO_MATCH_INCLUDE_MIN = 0;

/** Inclusive upper bound for audio match include seconds. */
export const GIP_EXPORT_AUDIO_MATCH_INCLUDE_MAX = 300;

/**
 * Builds yup schema for a customizable audio-match include duration in seconds.
 * Valid values must stay between 0 and 300 (inclusive).
 */
function audioMatchIncludeSecondsSchema() {
  return yup
    .number()
    .required()
    .min(GIP_EXPORT_AUDIO_MATCH_INCLUDE_MIN)
    .max(GIP_EXPORT_AUDIO_MATCH_INCLUDE_MAX);
}

export function useGipExportSetup(
  initialConfig: auditReports.GipEvidenceExportOptionsDto | undefined,
  reportType: string,
) {
  const auditClientConfigQuery = useAuditClientConfigQuery();

  const definitionsQuery = auditReports.useListReportDefinition({ reportType });

  if (!auditClientConfigQuery.data || !definitionsQuery.data) {
    return;
  }

  const pathFormats = auditClientConfigQuery.data.evidenceExport?.pathFormats ?? [];

  const initialDefinitionId = definitionsQuery.data?.find((d) => d.isDefault)?.id;

  const initialValues: auditReports.GipEvidenceExportOptionsDto = initialConfig ?? {
    audioMatchIncludeBefore: 60,
    audioMatchIncludeAfter: 60,
    ...(initialDefinitionId ? { definitionId: initialDefinitionId } : { definitionId: undefined }),
    pathFormat: {
      formatId: pathFormats.find((f) => f.default)?.id || pathFormats[0]?.id || undefined,
      formatCustomText: undefined,
    },
  };

  return {
    pathFormats: auditClientConfigQuery.data?.evidenceExport?.pathFormats ?? [],
    initialValues,
    validationSchema: yup.object().shape({
      audioMatchIncludeBefore: audioMatchIncludeSecondsSchema(),
      audioMatchIncludeAfter: audioMatchIncludeSecondsSchema(),
      excludeVersion: yup.boolean(),
      publicLink: yup.boolean(),
      definitionId: yup.string(),
    }),
    definitions: definitionsQuery.data,
  };
}
